export const API_CMS = {
  url: process.env.REACT_APP_CMS_URL || '/ms-cms/api/v2'
};
